import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import rootReducer from './containers/rootReducer';
import theme from './theme';

import './App.css';
import Landing from './containers/Landing';
import Simulator from './containers/Simulator';
import NewProject from './containers/NewProject';
import Inputs from './containers/Inputs';
import ProjectDashboard from './containers/ProjectsDashboard';
import ClientsDashboard from './containers/ClientsDashboard';
import Home from './containers/Home';
import AddClient from './containers/AddClient';
import NavBar from './containers/NavBar';

const store = createStore(
    rootReducer,
    {},
    compose(applyMiddleware(thunk)),
);

const App = () => (
    <Provider store={store}>
        <MuiThemeProvider muiTheme={theme}>
            <BrowserRouter>
                <LastLocationProvider>
                    <Switch>
                        <div className="App">
                            <NavBar />
                            <Route path="/" exact component={Landing} />
                            <Route path="/simulator/:projectId" component={Simulator} />
                            <Route path="/my-solar-benefits/:token" exact component={Simulator} />
                            <Route path="/home" component={Home} />
                            <Route path="/customer" component={ProjectDashboard} />
                            <Route path="/customers" component={ClientsDashboard} />
                            <Route path="/addclient" component={AddClient} />
                            <Route path="/newproject" component={NewProject} />
                            <Route path="/inputs" component={Inputs} />
                        </div>
                    </Switch>
                </LastLocationProvider>
            </BrowserRouter>
        </MuiThemeProvider>
    </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js